var Portfolio = {};

Portfolio.init = function () {
	const els = document.getElementsByClassName('portfolio');

	if (!els.length) {
		return;
	}

	Portfolio.el = els[0];

	const modal = document.getElementById('portfolioModal');
	const image = document.getElementById('portfolioModalImage');
	const video = document.getElementById('portfolioModalVideo');

	modal.addEventListener('show.bs.modal', event => {
		const thumbnail = event.relatedTarget;
		const mediaType = thumbnail.getAttribute('data-bs-type');
		const mediaSrc = thumbnail.getAttribute('data-bs-src');

		if (mediaType === 'photo') {
			image.src = mediaSrc;
			image.classList.remove('d-none');
			video.classList.add('d-none');
			video.pause();
		} else if (mediaType === 'video') {
			video.querySelector('source').src = mediaSrc;
			video.load();
			video.classList.remove('d-none');
			image.classList.add('d-none');
			video.muted = true;
			video.play();
		}
	});

	modal.addEventListener('hidden.bs.modal', () => {
		image.src = '';
		video.querySelector('source').src = '';
		video.pause();
	});
};

document.addEventListener("DOMContentLoaded", function() {
	Portfolio.init();
});
